<template>
  <div>
    <div class="w-full vx-col mb-base">
      <vs-card title="Add New Customer" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
           <div class="mb-4 mr-4 md:mb-0 ag-grid-table-actions-left">
              <h4>Outbound API</h4>
          </div>
            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
            <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="filterInit">Export Excel</vs-button>

            </div>
        </div>
      </vs-card>
      <vs-prompt @accept="exportOutbound" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <label class="vs-input--label">Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <flat-pickr class="w-full p-2 vx-col" v-model="filter.dateNow" />
                </vs-row>
            </div>
        </vs-prompt>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/flatpickr.css";
import { saveAs } from "file-saver";
import moment from "moment";

export default {
    components: {
        vSelect,
        flatPickr
    },
  data() {
    return {
      isLoading: false,
      isForm: false,
      file:null,
      reference:"",
      showFilter: false,
      filter: {
        dateNow: moment().format("YYYY-MM-DD").toString()
    },
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    filterInit() {
        this.showFilter = true;
    },
    exportOutbound() {
      // this.currentPage = 1;
      // this.fetchData();
      this.isLoading = true;
      this.$http
        .post("support/outbound_api", this.filter, {
          responseType: "blob"
        })
        .then(response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });
          this.isLoading = false;
          saveAs(blob, "Outbound_api.xlsx");
        });
    },
  },
  mounted() {
  }
};
</script>
